import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useHighwayPassesApi } from "../../http/highwayPasses/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteHighwayPassDialogProps = {
  highwayPassId: string;
  carId?: string;
  onClose: (success?: boolean) => void;
};
const DeleteHighwayPassDialog: FC<DeleteHighwayPassDialogProps> = ({ highwayPassId, carId, onClose }) => {
  const i18n = useI18n();
  const highwayPassesApi = useHighwayPassesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.highwayPasses.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            highwayPassesApi
              .deleteAdminHighwayPass(highwayPassId, carId)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .then(() => onClose(true))
              .finally(() => {
                setIsSubmitting(false);
              });
          },
        },
      ]}
    >
      {i18n.t.highwayPasses.questions.delete}
    </ModalDialog>
  );
};

export default DeleteHighwayPassDialog;
